import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { Paragraph, Heading, ListItem } from '@agilytics/components';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return <Paragraph>{children}</Paragraph>;
    },
    [BLOCKS.HEADING_1]: (node, children) => {
      return <Heading level={1}>{children}</Heading>;
    },
    [BLOCKS.HEADING_2]: (node, children) => {
      return <Heading level={2}>{children}</Heading>;
    },
    [BLOCKS.HEADING_3]: (node, children) => {
      return <Heading level={3}>{children}</Heading>;
    },
    [BLOCKS.HEADING_4]: (node, children) => {
      return <Heading level={4}>{children}</Heading>;
    },
    [BLOCKS.HEADING_5]: (node, children) => {
      return <Heading level={5}>{children}</Heading>;
    },
    [BLOCKS.HEADING_6]: (node, children) => {
      return <Heading level={6}>{children}</Heading>;
    },
    [BLOCKS.LIST_ITEM]: (node, children) => {
      return <ListItem>{children}</ListItem>;
    },
  },
};

export default function Formatted({ content }) {
  return documentToReactComponents(content, options);
}
